import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <g transform="translate(-14 -10)">
      <path
        fill="currentColor"
        d="M24.333 13.667a6.667 6.667 0 0 1 5.264 10.758l4.74 4.733-1.176 1.175-4.74-4.733a6.667 6.667 0 1 1-4.089-11.933zm0 1.666a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
      />
    </g>
  </React.Fragment>,
  `SearchIcon`
);
